export const cicdTestingModule = {
  id: "cicd-testing-enterprise", 
  title: "CI/CD Testing Integration",
  description: "Integrate automated testing into CI/CD pipelines for continuous quality assurance.",
  content: `## Overview\nImplement testing gates in CI/CD pipelines using GitHub Actions, Jenkins, and Azure DevOps for automated quality control.`,
  duration: 75
};